// Types for Date Range feature components
import { CalendarDate, DateValue } from '@internationalized/date';
import type { RangeValue } from '@react-types/shared';

export type VesselLocationsDateOption = 'latest' | 'specific';
export type AnalysisDateRangeOption = 'past12Months' | 'yearToDate' | 'past3Years' | 'specificYear' | 'specificRange';

export type TDateRangeState = {
	vesselLocationsDate: IVesselLocationsDateFormData;
	analysisDateRange: IAnalysisDateRangeFormData;
};

export interface IVesselLocationsDateFormData {
	selectedOption: VesselLocationsDateOption;
	specificDate: CalendarDate | null;
}

export interface IAnalysisDateRangeFormData {
	selectedOption: AnalysisDateRangeOption | null;
	specificYear: number | null;
	dateRange: RangeValue<DateValue> | null;
	yearMonthRange?: RangeValue<number> | null;
}

export interface IDateRangeFormData {
	vesselLocationsDate: IVesselLocationsDateFormData;
	analysisDateRange: IAnalysisDateRangeFormData;
}

// Constants for options
export const VESSEL_LOCATION_OPTIONS = {
	LATEST: 'latest' as const,
	SPECIFIC: 'specific' as const,
} as const;

export const DATE_RANGE_OPTIONS = {
	PAST_12_MONTHS: 'past12Months' as const,
	YEAR_TO_DATE: 'yearToDate' as const,
	PAST_3_YEARS: 'past3Years' as const,
	SPECIFIC_YEAR: 'specificYear' as const,
	SPECIFIC_RANGE: 'specificRange' as const,
} as const;

// Default values
export const DEFAULT_VESSEL_LOCATION_DATA: IVesselLocationsDateFormData = {
	selectedOption: VESSEL_LOCATION_OPTIONS.LATEST,
	specificDate: null,
};

export const DEFAULT_DATE_RANGE_DATA: IAnalysisDateRangeFormData = {
	selectedOption: DATE_RANGE_OPTIONS.PAST_12_MONTHS,
	specificYear: null,
	dateRange: null,
	yearMonthRange: null,
};

export const DATE_RANGE_FEATURE = "featureDateRange";

export const actions = {
	SET_DATE_RANGE: `${DATE_RANGE_FEATURE}/setDateRange`,
	INITIALIZE_DATE_RANGE_FROM_MAIN_MAP: `${DATE_RANGE_FEATURE}/initializeDateRangeFromMainMap`,
};
